import React from "react";
import dec from "ramda/src/dec";
import inc from "ramda/src/inc";
import { usePopupContext } from "../../contexts/PopupContext/context";
import { Button } from "../../UI/Button";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { PlacementWorksheetBottomPopup } from "../PlacementWorksheetBottomPopup";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { useNetwork } from "../../hooks/useNetwork";

export const BOTTOM_POPUP_HEIGHT = "15vh";

export const PWSelectedResidentBottomPopup = () => {
  const { selectedResidents, setSelectedResidents } = usePopupContext();
  const { l2Id } = usePlacementWorksheetContext();
  const { selectedNetwork, getL2 } = useNetwork();

  // Check if matching round is archived
  const isArchived = React.useMemo(() => {
    if (!l2Id || !selectedNetwork) return false;
    const l2Info = getL2(selectedNetwork.l1Id, l2Id);
    return l2Info?.matchingRoundStatus === "ARCHIVED";
  }, [l2Id, selectedNetwork, getL2]);

  const handleCloseBottomPopup = () => {
    setSelectedResidents([]);
  };

  // Don't show bottom popup if matching round is archived
  if (isArchived) {
    return null;
  }

  return (
    <PlacementWorksheetBottomPopup open={!!selectedResidents?.length}>
      <Grid container alignItems="center" justifyContent="center" minHeight={BOTTOM_POPUP_HEIGHT} gap={2}>
        <Grid item>
          <Typography>
            Select a row to place{" "}
            <b>
              {selectedResidents?.map(
                (resident, idx, array) =>
                  resident ? `${resident.firstName || ''} ${resident.lastName || ''}${dec(array.length) === inc(idx) ? ", " : ""}` : ''
              )}
            </b>
          </Typography>
        </Grid>
        <Grid item>
          <Button onClick={handleCloseBottomPopup}>Cancel</Button>
        </Grid>
      </Grid>
    </PlacementWorksheetBottomPopup>
  );
};
